<dp-header [rightActions]="rightActions" [leftActions]="leftActions" [moreMenuGroups]="moreMenuGroups"></dp-header>

<dp-search [searchAvailableOptions]="searchAvailableOptions" [showSavedSearchButtons]="false" [hidden]="!isSearchVisible()"
    [searchConfig]="searchConfig" (searchInfo)="sendSearch($event)" (clearResults)="clearSearch()" (hide)="hideSearch()">
</dp-search>
